import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import pButton from '@/common/pButton/pButton.vue'
import {useAuthPopup} from "@/authSection/store/authPopup";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpBlock',
  setup(__props) {

const authPopupStore = useAuthPopup()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "button_login",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(authPopupStore).openSignForm && _unref(authPopupStore).openSignForm(...args)))
    }, " Войти "),
    _createVNode(pButton, {
      class: "button_reg",
      onClick: _unref(authPopupStore).openLoginForm
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Регистрация ")
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})